<template>
  <div
    class="
      tw-w-full
      tw-h-full
      tw-fixed
      tw-block
      tw-top-0
      tw-left-0
      tw-bg-white
      tw-opacity-75
      tw-z-50
    "
    :class="{ 'tw-absolute': absolute }"
  >
    <LoadingIndicator
      :size="64"
      class="tw-opacity-75 tw-top-1/2 tw-my-0 tw-mx-auto tw-relative tw--mt-16"
    />
  </div>
</template>

<script>
import LoadingIndicator from '@/components/shared/LoadingIndicator'

export default {
  components: {
    LoadingIndicator,
  },
  props: {
    absolute: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
}
</script>

<style></style>
